var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.de)?_c('div',{staticClass:"object-translation-container"},[_c('div',{staticClass:"query-detail-row"},[_c('div',{staticClass:"field-container"},[_c('label',{staticClass:"query-label"},[_vm._v(_vm._s(_vm.objectText))]),_c('div',{staticClass:"selection"},[_vm._v(_vm._s(_vm.de.object ? _vm.de.object.label : ""))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }